import React, { useEffect, useState } from "react";
import {
  ExclamationCircleOutlined,
  LeftOutlined,
  LoadingOutlined,
  RightOutlined,
} from "@ant-design/icons";
// import styled from "styled-components";
import {
  DatePicker,
  Modal,
  Radio,
  Steps,
  Table,
  Form,
  Pagination,
  message,
} from "antd";
import type { RadioChangeEvent } from "antd";
import type { PaginationProps } from "antd";
import type { RangePickerProps } from "antd/es/date-picker";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../components/Button/Button";
import UploadDataForm from "../../components/SalesData/UploadDataForm";
import MapData from "../../components/SalesData/MapData";
import ConfirmData from "../../components/SalesData/ConfirmData";
import {
  Actions,
  MasterRequiredColumn,
  PageSize,
  UploadStatus,
} from "../../shared/constant";
import { RootState } from "../../redux/rootReducer";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import salesDataConstants from "../../redux/constants/salesDataContants";
import {
  closeDateConversionDialog,
  deleteProcessedFile,
  deleteSalesFile,
  downloadSalesFile,
  getFileColumns,
  getMasterData,
  getSalesFiles,
  mapSalesDataToRawData,
  postSalesFile,
  processMasterData,
  processMasterDataConfirm,
  resetDownloadSalesFile,
  resetSalesFiles,
  showDateConversionDialog,
} from "../../redux/actions/salesDataActions";
import SalesTableActions from "../../components/SalesData/SalesTableActions";
import validateMessages from "../../utils/validate";
import dateUtils from "../../utils/dateUtils";
import Icon from "../../components/Icon/Icon";
import MasterDataView from "../../components/SalesData/MasterDataView";
import { failedMappedData, mappingData, processingData } from "./constants";
import tableUtils from "../../utils/tableUtils";
import { SalesDataColumn } from "../../shared/table/columns";
import { IKeyValue } from "../../shared/table/types";
import SearchComponent from "../../components/_shared/SearchComponent";

const { confirm } = Modal;
const { RangePicker } = DatePicker;
const { Step } = Steps;

// const StyledModal = styled(Modal)<{ height: string }>`
//   .ant-modal-content {
//     min-height: ${(props: any) => props.height};
//   }
// `;
// interface StyledModalProps {
//   height: string;
//   [k: string]: any;
// }
// const DynamicStyledModal: React.FC<StyledModalProps> = ({
//   height,
//   children,
//   ...rest
// }) => {
//   return (
//     <StyledModal height={height} {...rest}>
//       {children}
//     </StyledModal>
//   );
// };

interface UploadDescription {
  text: string;
  subtext: string;
}

function SalesData() {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [file, setFile] = useState(null);
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [effect, setEffect] = useState(false);
  const dispatch = useDispatch();
  const {
    masterColumns,
    salesFiles,
    resSalesFiles,
    newFile,
    pending,
    fulfilled,
    error,
    salesFilesPending,
    downloadedSalesFileResponse,
    downloadSalesFilePending,
    dateConversionDialog,
  } = useSelector((state: RootState) => state.salesData);
  const { masterDataResponse } = useSelector(
    (state: RootState) => state.salesData,
  );

  const [uploadStatus, setUploadStatus] = useState<string>(
    UploadStatus.MAPPING,
  );
  const [uploadDesc, setUploadDesc] = useState<UploadDescription>(mappingData);

  const [fileID, setFileID] = useState("");
  const [action, setAction] = useState("");
  const [processCheckLoading, setProcessCheckLoading] = useState(false);
  const [dateConversionOption, setDateConversionOption] = useState<number>(0);

  const [stepForm] = Form.useForm();

  // useEffect(() => {
  //   console.log("STEP: ", currentStep);
  // }, [currentStep]);

  useEffect(() => {
    dispatch(resetSalesFiles());
  }, []);

  useEffect(() => {
    if (dateConversionDialog?.visible) {
      setDateConversionOption(0);
    }
  }, [dateConversionDialog?.visible]);

  useEffect(() => {
    dispatch(
      getSalesFiles({
        page,
        searchText,
        from: dateRange.from,
        to: dateRange.to,
      }),
    );
  }, [page, effect]);

  const handleSearch = (value: string) => {
    setSearchText(value);
    setPage(1);
    setEffect(!effect);
  };

  const onRangeChange: RangePickerProps["onChange"] = (dates, dateStrings) => {
    if (dates) setDateRange({ from: dateStrings[0], to: dateStrings[1] });
    else setDateRange({ from: "", to: "" });
    setPage(1);
    setEffect(!effect);
  };

  const showModal = () => {
    setAction("");
    setVisible(true);
  };

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleCancel = () => {
    if (currentStep !== 0) {
      setEffect(!effect);
    }
    setCurrentStep(0);
    setVisible(false);
    setUploadStatus(UploadStatus.MAPPING);
    setUploadDesc(mappingData);
    setFileID("");
    setFile(null);
    setAction("");
  };

  const UploadFile = (content: any) => {
    setFile(content);
  };

  const steps = [
    {
      title: "Upload Sales Data",
      content: <UploadDataForm onFileUpload={UploadFile} />,
      fields: ["file_data", "currency", "distributor", "platform"],
    },
    {
      title: "Mapping Data with CLAP",
      content: <MapData />,
      fields: MasterRequiredColumn,
    },
    {
      title: "View Mapping",
      content: <MapData displayMapping />,
    },
    {
      title: "Confirm and Map",
      content: <ConfirmData />,
    },
  ];

  const handleOk = async () => {
    try {
      await stepForm.validateFields(steps[currentStep].fields);
    } catch (errorInfo) {
      return;
    }

    /* const formFields = stepForm.getFieldsValue(); */
    const formFields = stepForm.getFieldsValue(true);
    // console.log(formFields);

    // 0: Upload Sales Data
    // 1: Mapping Data with Clap
    // 2: View Mapping
    // 3: Confirm and Map
    // 4: Mapping and Mapped
    // 5: Sales Data View and Process
    // 6. Processing; Sucess or Failed state

    if (currentStep === 0) {
      const formData = new FormData();
      formData.append("platform", formFields.platform);
      if (formFields.distributor)
        formData.append("distributor", formFields.distributor);
      formData.append("currency", formFields.currency);
      formData.append("raw_file", file as unknown as Blob);
      if (formFields.period) {
        formData.append(
          "from_date",
          dateUtils.defaultFormat(formFields.period[0]),
        );
        formData.append(
          "to_date",
          dateUtils.defaultFormat(formFields.period[1]),
        );
      }
      if (formFields.comment) formData.append("comment", formFields.comment);
      // if (formFields.comment !== "undefined")
      //   formData.append("comment", formFields.comment);

      dispatch(postSalesFile(formData));
      setAction(Actions.UPLOAD_FILE);
    } else if (currentStep === 1 || currentStep === 2) {
      setFileID(newFile?.id);
      setCurrentStep(currentStep + 1);
    } else if (currentStep === 3) {
      // console.log(masterColumns);
      const obj: any = {};
      masterColumns.forEach((element) => {
        obj[element.masterColumn] = element.rawColumn || "";
      });
      dispatch(
        mapSalesDataToRawData({
          id: newFile.id,
          mapping: obj,
        }),
      );
      setCurrentStep(currentStep + 1);
    }
  };

  const afterClose = () => {
    stepForm.resetFields();
    setCurrentStep(0);
    setAction("");
  };

  useEffect(() => {
    if (action === Actions.DELETE) {
      if (fulfilled) message.success("File successfully deleted");
      setAction("");
      if (salesFiles.length === 1 && page > 1) setPage(page - 1);
      setEffect(!effect);
      return;
    }
    if (!visible || currentStep === 6) return;
    if (currentStep === 4) {
      if (fulfilled) {
        setUploadStatus(UploadStatus.MAPPING);
        setUploadDesc(mappingData);
        return;
      }
      if (error) {
        setUploadStatus(UploadStatus.FAILED);
        setUploadDesc(failedMappedData);
        return;
      }
    }
    if (currentStep === 5) {
      setLoading(false);
      if (fulfilled) {
        // console.log("got master data");
        return;
      }
    }

    /* currentStep 0 */
    if (action === Actions.UPLOAD_FILE && currentStep === 0) {
      if (fulfilled) {
        dispatch(getFileColumns({ id: newFile?.id }));
        setAction(Actions.RETRIEVE_FILE_COLUMNS);
        setCurrentStep(currentStep + 1);
      }
    }
    /* currentStep 1 and map from dropdown */
    if (action === Actions.RETRIEVE_FILE_COLUMNS && currentStep === 1) {
      if (fulfilled) {
        setAction("");
      }
    }
  }, [pending]);

  useEffect(() => {
    if (!visible) return;
    if (currentStep === 4) {
      setUploadStatus(UploadStatus.MAPPING);
      setUploadDesc(mappingData);
    }
  }, [currentStep]);

  const getMapDataIllustration = () => {
    switch (uploadStatus) {
      case UploadStatus.MAPPING:
        return <div className="text-primary">MAPPING ..</div>;
      case UploadStatus.MAPPED:
        return (
          <Icon icon="check_circle" className="h-20 w-20 text-dodger-blue" />
        );
      case UploadStatus.PROCESSING:
        return <div className="text-primary">PROCESSING ..</div>;
      case UploadStatus.PROCESSED:
        return <Icon icon="check_circle" className="h-20 w-20 text-success" />;

      default:
        return <div className="text-danger">FAILED</div>;
    }
  };

  const handlePageChange: PaginationProps["onChange"] = (p) => {
    setPage(p);
  };

  useEffect(() => {
    if (downloadSalesFilePending) {
      message.loading("Downloading ...", 0);
    }
    if (!downloadSalesFilePending && downloadedSalesFileResponse) {
      message.destroy();
      dispatch(resetDownloadSalesFile());
    }
  }, [downloadSalesFilePending]);

  const onfileDelete = (record: IKeyValue) => {
    confirm({
      title: "Are you sure to delete this file?",
      icon: <ExclamationCircleOutlined />,
      // content: "Some descriptions",
      okText: "Yes",
      // okType: "danger",
      cancelText: "No",
      centered: true,
      onOk: () => {
        const filterParams = {
          page,
          searchText,
          from: dateRange.from,
          to: dateRange.to,
        };
        if (record.status === UploadStatus.PROCESSED)
          dispatch(deleteProcessedFile({ file_id: record.id, filterParams }));
        else dispatch(deleteSalesFile({ file_id: record.id, filterParams }));
        setAction(Actions.DELETE);
      },
      onCancel() {},
    });
  };
  const onFileProcess = (record: IKeyValue) => {
    setAction(Actions.ROW_PROCESS);
    setFileID(record.id.toString());
    setVisible(true);
    setCurrentStep(5);
    setLoading(true);
    dispatch(getMasterData({ file_id: record.id, page: 1 }));
  };
  const onFileMap = (record: IKeyValue) => {
    setAction(Actions.RETRIEVE_FILE_COLUMNS);
    dispatch(getFileColumns({ id: record.id }));
    setFileID(record.id.toString());
    setCurrentStep(1);
    setVisible(true);
  };
  const onFileDownload = (record: IKeyValue) => {
    dispatch(downloadSalesFile({ id: record.id, filename: record.title }));
  };

  const onView = () => {
    setAction(Actions.ROW_PROCESS);
    setCurrentStep(currentStep + 1);
    setLoading(true);
    dispatch(getMasterData({ file_id: fileID, page: 1 }));
  };
  const handleProcess = async () => {
    if (!fileID || processCheckLoading) return;
    setProcessCheckLoading(true);
    try {
      const dateConversionResponse = await api.get(
        `${Endpoint.getDateConversion}${fileID}/`,
      );
      const dateRanges: string[] = dateConversionResponse.data ?? [];

      if (dateRanges.length === 0) {
        setCurrentStep(currentStep + 1);
        setUploadStatus(UploadStatus.PROCESSING);
        setUploadDesc(processingData);
        dispatch(processMasterData({ file_id: fileID }));
      } else {
        dispatch(showDateConversionDialog({ file_id: fileID, dateRanges }));
      }
    } catch (e) {
      dispatch({
        type: salesDataConstants.PROCESS_MASTER_DATA_FAILURE,
        err: e,
      });
    } finally {
      setProcessCheckLoading(false);
    }
    setAction("");
  };

  const handleDateConversionConfirm = () => {
    if (!dateConversionDialog) return;
    setCurrentStep(currentStep + 1);
    setUploadStatus(UploadStatus.PROCESSING);
    setUploadDesc(processingData);
    dispatch(
      processMasterDataConfirm({
        file_id: dateConversionDialog.fileId,
        date_conversion: dateConversionOption > 0,
      }),
    );
    dispatch(closeDateConversionDialog());
    setDateConversionOption(0);
  };

  const handleDateConversionCancel = () => {
    dispatch(closeDateConversionDialog());
    setDateConversionOption(0);
  };

  // const getModalHeight = (): string => {
  //   if (action === Actions.ROW_PROCESS) return "";
  //   return "";
  // };

  return (
    <div>
      <div className="flex justify-between items-center">
        <div className="text-heading20">Sales Data</div>
        <div>
          <Button type="primary" onClick={showModal}>
            Upload Sales Data
          </Button>
          <Modal
            visible={visible}
            maskClosable={false}
            title={currentStep < 5 ? "Upload Data File" : "Process Data File"}
            centered
            width={action === Actions.ROW_PROCESS ? "100%" : 820} // 740
            className={action === Actions.ROW_PROCESS ? "row-process" : ""}
            // height={getModalHeight()}
            // bodyStyle={getModalHeight()}
            // style={{ minHeight: "100vh" }}
            onOk={handleOk}
            onCancel={handleCancel}
            afterClose={afterClose}
            footer={[
              <Button key="cancel" onClick={handleCancel}>
                {[4, 6].includes(currentStep) ? "Close" : "Cancel"}
              </Button>,
              currentStep < 4 && [
                currentStep > 1 && (
                  <Button
                    key="back"
                    type="ghost"
                    onClick={handleBack}
                    icon={<LeftOutlined className="text-xs" />}
                  >
                    Back
                  </Button>
                ),
                <Button
                  key="submit"
                  type="primary"
                  loading={
                    currentStep === 0 &&
                    action === Actions.UPLOAD_FILE &&
                    (pending as boolean)
                  }
                  onClick={handleOk}
                  disabled={!newFile && currentStep === 1}
                >
                  {currentStep === 3 ? "Map Data" : "Next"}
                  {currentStep !== 3 && <RightOutlined className="text-xs" />}
                </Button>,
              ],
              currentStep === 5 && (
                <Button
                  key="submit"
                  type="primary"
                  loading={processCheckLoading}
                  disabled={!masterDataResponse?.count || processCheckLoading}
                  onClick={handleProcess}
                >
                  Start Processing
                </Button>
              ),
            ]}
          >
            {currentStep < 4 && (
              <Form
                form={stepForm}
                layout="vertical"
                name="uploadProcessForm"
                validateMessages={validateMessages}
              >
                <Steps
                  size="small"
                  current={currentStep}
                  className="bg-cultured h-12 items-center px-6"
                >
                  {steps.map((item) => (
                    <Step key={item.title} title={item.title} />
                  ))}
                </Steps>
                <div className="m-6">{steps[currentStep].content}</div>
              </Form>
            )}
            {(currentStep === 4 || currentStep === 6) && (
              <div className="m-6 h-[300px] grid place-content-center text-center text-subheading16 ">
                <div>{getMapDataIllustration()}</div>
                <div className="mb-2.5 font-bold">{uploadDesc.text}</div>
                <div className="text-secondary">
                  <div>
                    {uploadStatus === UploadStatus.MAPPING ||
                    uploadStatus === UploadStatus.PROCESSING
                      ? uploadDesc.subtext.split(".").map((item) => {
                          return <div key={item}>{item}.</div>;
                        })
                      : uploadDesc.subtext}
                  </div>
                </div>
                {uploadStatus === UploadStatus.MAPPED && (
                  <div className="mt-2.5">
                    <Button
                      type="primary"
                      color="text-dodger-blue"
                      ghost
                      onClick={onView}
                    >
                      View and Process Data
                    </Button>
                  </div>
                )}
              </div>
            )}
            {currentStep === 5 && (
              <div className="m-6">
                {!loading && <MasterDataView fileID={fileID} />}
              </div>
            )}
          </Modal>
        </div>
      </div>
      <div className="mt-5 mb-4 space-x-4">
        <SearchComponent handleSearch={handleSearch} />
        <RangePicker onChange={onRangeChange} className="w-[264px]" />
      </div>

      {/* TODO create a Suspense; to handle all the tables loading state */}
      {/* TODO globalReducers for temporarily store values  */}
      <div>
        <Table
          rowKey={(record: any) => {
            return record.id;
          }}
          columns={tableUtils.buildColumns(
            salesFiles,
            SalesDataColumn,
            SalesTableActions(
              onfileDelete,
              onFileProcess,
              onFileMap,
              onFileDownload,
            ),
          )}
          dataSource={salesFiles}
          pagination={false}
          size="middle"
          scroll={{ x: 1024 }}
          loading={{
            spinning: salesFilesPending as boolean,
            indicator: <LoadingOutlined style={{ fontSize: 34 }} />,
          }}
        />
      </div>
      <Modal
        title="Date Conversion"
        visible={!!dateConversionDialog?.visible}
        onOk={handleDateConversionConfirm}
        onCancel={handleDateConversionCancel}
        centered
        width={480}
        okText="Process"
        bodyStyle={{ padding: "24px 24px 8px" }}
        className="date-conversion-modal"
      >
        <div className="date-conversion-modal__content">
          <div className="text-sm text-black/60 mb-4">
            Select how you would like to process the date ranges for sales file:
          </div>
          <Radio.Group
            value={dateConversionOption}
            onChange={(e: RadioChangeEvent) =>
              setDateConversionOption(e.target.value as number)
            }
            className="date-conversion-modal__radios"
          >
            {dateConversionDialog?.dateRanges?.map((range: string, idx: number) => (
              <div key={idx} className="date-conversion-modal__radio-item">
                <Radio value={idx}>
                  <span className="date-conversion-modal__radio-label">
                    {range}
                  </span>
                </Radio>
              </div>
            ))}
          </Radio.Group>
        </div>
      </Modal>

      <div className="text-right mt-4">
        <Pagination
          current={page}
          pageSize={PageSize.DEFAULT}
          onChange={handlePageChange}
          total={resSalesFiles?.count}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
}

export default SalesData;
